import { t } from '@lingui/macro';

import {
    useSelectorThreeEssentialsUrl,
    useSelectorReadingUrl,
    useSelectorWritingUrl,
    useSelectorMathematicsUrl
} from '../../../configuration/configuration.selectors';
import {
    mappedIcons, Icons, NavigationUrls
} from '../product-switcher.types';

export const productSwitchConfigs = {
    threeEssentials: {
        title: '3 Essentials',
        description: t`productSwitcher.threeEssentialsDescription`
    },
    reading: {
        title: 'Reading',
        description: t`productSwitcher.readingDescription`
    },
    writing: {
        title: 'Writing',
        description: t`productSwitcher.writingDescription`
    },
    mathematics: {
        title: 'Mathematics',
        description: t`productSwitcher.mathematicsDescription`
    }
};

export const useGetMappedConfig = () => {
    const mappedNavigationUrls = {
        [NavigationUrls.threeEssentials]: useSelectorThreeEssentialsUrl(),
        [NavigationUrls.reading]: useSelectorReadingUrl(),
        [NavigationUrls.writing]: useSelectorWritingUrl(),
        [NavigationUrls.mathematics]: useSelectorMathematicsUrl()
    };
    const getMappedIcons = (icon: Icons) => {
        return mappedIcons[icon];
    };
    const getMappedConfig = (id: keyof typeof productSwitchConfigs) => {
        return ({ ...productSwitchConfigs[id] });
    };
    const getMappedNavigationUrls = (navigationId: NavigationUrls) => {
        return mappedNavigationUrls[navigationId];
    };

    return {
        productSwitchConfigs,
        getMappedIcons,
        getMappedConfig,
        getMappedNavigationUrls
    };
};
